// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Modal_wrap__N2WxT","mobileSmall":"Modal_mobileSmall__1-uxQ","inner":"Modal_inner__3l3lL","modal":"Modal_modal__1I1hs","close":"Modal_close__24lym"};